import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { HelperService, DialogService, AuthService } from 'src/app/services';
import { ConstantsHelper } from 'src/assets/constants/constants.helper';
import { MediaObserver } from '@angular/flex-layout';
import * as _ from 'lodash';

@Component({
  selector: 'esc-maintenance-detail',
  templateUrl: './maintenance-detail.component.html',
  styleUrls: ['./maintenance-detail.component.scss']
})
export class MaintenanceDetailComponent implements OnInit {
  @Input() detail;
  @Input() detailKeys = [];
  @Input() loadError;
  @Input() type;
  @Input() disableEdit;
  @Input() disableEditMessage;
  @Input() moduleCode;
  @Input() displayMode;
  @Input() descriptionOnly = false;
  @Output() edit = new EventEmitter;
  @Output() closeDetail = new EventEmitter;
  @Output() downloadQR = new EventEmitter;

  constructor(
    public helper: HelperService,
    public media: MediaObserver,
    public authService: AuthService,
    private dialogService: DialogService,
    ) { }

  public detailData;
  public constants = ConstantsHelper;

  ngOnInit() {
    // console.log(this.moduleCode)
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes.detail.currentValue)
    this.detailData = _.clone(changes.detail.currentValue);
  }

  close() {
    this.closeDetail.next(true);
  }

  modify() {
    if(this.disableEdit) {
      this.dialogService.openSnackBar(this.disableEditMessage);
      return;
    }
    this.edit.next(true);
  }

  downloadRMQR() {
    this.downloadQR.emit(true)
  }
}